import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Certificate } from '@certificates/interfaces/certificate';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import moment from 'moment';

library.add(faSync);

@Component({
  name: 'bpc-certificate-table',

  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class CertificateTable extends mixins(AbstractTable) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: Certificate = null;
  public entityName = 'certificate';
  public pluralEntityName = 'certificates';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'certificates';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  setEntityAttributesAfterSave() {
    const newEntity = {} as Certificate;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  setCertificateDates(category) {
    if (this.modelLoaded && this.modelLoaded.certificate_category_id === category.id) {
      this.$set(
        this.$refs.stdForm?.formModel,
        'start_date',
        this.modelLoaded.certificate_start_date,
      );
      this.$set(this.$refs.stdForm?.formModel, 'validity_date', this.modelLoaded.validity_date);
    } else {
      let startDate = null;
      if (category['start_date_type_value'] === 'fixed_date') {
        startDate = category['fixed_start_date'];
      } else {
        startDate = moment(new Date()).format('YYYY-MM-DD');
      }

      this.$set(this.$refs.stdForm?.formModel, 'start_date', startDate);

      let validityDate = null;
      if (category['end_date_type_value'] === 'fixed_date') {
        validityDate = category['fixed_end_date'];
      } else {
        validityDate = moment(startDate)
          .add(category['fixed_duration_number'], category['duration_type'])
          .format('YYYY-MM-DD');
      }

      this.$set(this.$refs.stdForm?.formModel, 'validity_date', validityDate);
    }
  }

  /* Lifecycle hooks */

  // created() {}
  mounted() {
    this.$root.$on('setCategoryFeatures', event => {
      this.setCertificateDates(event);
    });
  }
  // updated() {}
  destroyed() {
    this.$root.$off('setCategoryFeatures');
  }

  private modelLoaded;
  onModelLoaded(event) {
    this.modelLoaded = JSON.parse(JSON.stringify(this.$refs.stdForm?.formModel));
  }
}
